import { FormalOffer } from '../../myOffers/MyOffers.types';
import { ApplicantCallAction } from './applicantCallAction/ApplicantCallAction';
import BankDetailsAction from './bankDetailsAction/BankDetailsAction';
import DebitCardAction from './debitCardAction/DebitCardAction';
import { PennyTransferAction } from './pennyTransferAction/PennyTransferAction';
import OnfidoVerificationAction from './onfidoVerificationAction/OnfidoVerificationAction';
import IDNowAction from './idNowAction/IDNowAction';
import MajorShareholderCheckAction from './majorShareholderCheckAction/MajorShareholderCheckAction';
import SignDocumentAction from './signDocumentAction/SignDocumentAction';
import { TFundingRequirementsSteps } from './orderFundingRequirements';
import { TSignDocument } from './signDocumentAction/SignDocumentsHelper';

export const getStepItem = ({
    step,
    productType,
    triggerRefetchFundingRequirements
}: {
    step: TFundingRequirementsSteps['0'];
    productType: FormalOffer['product_type'];
    triggerRefetchFundingRequirements?: () => void;
}) => {
    const type = step.type.toUpperCase();
    switch (type) {
        case 'BANK_DETAILS':
            return <BankDetailsAction status={step.status} />;
        case 'DEBIT_CARD':
            return <DebitCardAction status={step.status} />;
        case 'APPLICANT_CALL':
            return (
                <ApplicantCallAction
                    productType={productType}
                    status={step.status}
                />
            );
        case 'PENNY_TRANSFER':
            return (
                <PennyTransferAction
                    status={step.status}
                    triggerRefetchFundingRequirements={
                        triggerRefetchFundingRequirements!
                    }
                />
            );
        case 'ONFIDO_VERIFICATION':
            return <OnfidoVerificationAction status={step.status} />;
        case 'IDNOW':
            return <IDNowAction status={step.status} />;
        case 'MAJOR_SHAREHOLDER_CHECK':
            return <MajorShareholderCheckAction status={step.status} />;
        case 'GUARANTEE':
        case 'MASTER_LOAN_AGREEMENT':
        case 'REASONABLE_EXPLANATION':
        case 'SECCI':
        case 'COMPANIES_HOUSE_CHARGE':
        case 'BUSINESS_INTERRUPTION_PAYMENT_OFFER_LETTER':
        case 'DATA_PROTECTION_DISCLOSURE_DECLARATION':
        case 'DATA_PROTECTION_DISCLOSURE_DECLARATION_GUARANTOR':
        case 'INFORMATION_DECLARATION':
            return <SignDocumentAction step={step as TSignDocument} />;
    }
};
